import React from "react";

export const SectionHeading = ({ eyebrow, title, subtitle, align = "left" }) => {
    return (
        <div className={`max-w-2xl ${align === "center" ? "mx-auto text-center" : ""}`}>
            {eyebrow && (
                <span className="ll-eyebrow text-brand-primary block mb-4" data-testid="section-eyebrow">
                    {eyebrow}
                </span>
            )}
            <h2 className="font-display text-[2.25rem] md:text-[3rem] lg:text-[3.4rem] leading-[1.05] text-brand-ink">
                {title}
            </h2>
            {subtitle && (
                <p className="mt-5 text-base md:text-lg leading-relaxed text-brand-ink/70 font-sans">
                    {subtitle}
                </p>
            )}
        </div>
    );
};

export default SectionHeading;
